// @flow
import * as React from 'react';
import classnames from 'classnames';

import { locationMarkerFactory } from './LocationMarker';
import { themr } from 'react-css-themr';
import { spiderLocationMarkerFactory } from 'common/components/core/markers/SpiderLocationMarker';
import { HighlightIcon } from 'common/components/core/icon';
import { SizeEnum } from 'common/enums/UIEnums';
import LocationGeocodeEditSelectors from 'common/redux/selectors/locationGeocodeEdit';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'common/components/core/router';
import { Loader } from 'common/components/core/loader/Loader';
import { dashboardColors } from 'common/enums/ColorEnum';
import { Icon } from '@locus-taxy/neo-ui';

import geocoderMarkerTheme from './GeocoderMarker.scss';

const MarkerIcon = ({
    originalConfidenceColor,
    markerIcon,
    markerLabel,
    theme,
    isMarkerLoading
}) => {
    const markerLoader = (
        <Loader
            backgroundColor={dashboardColors.transparent}
            loaderColor={dashboardColors.white}
            active
            relative
            size={SizeEnum.Small}
        />
    );
    return (
        <HighlightIcon
            highlightWrapBgColor={originalConfidenceColor}
            highlightIcon={originalConfidenceColor}
            icon={markerIcon}
            numberLabel={isMarkerLoading ? markerLoader : markerLabel}
            theme={theme}
            className={theme.confidenceIconWrap}
        />
    );
};

const NeoMarkerIcon = ({ markerIcon }) => {
    return <Icon icon={markerIcon} size="small" color="white" />;
};

const GeocoderMarkerComponent = locationMarkerFactory({
    Icon: MarkerIcon
});

const GeocoderNeoMarkerComponent = locationMarkerFactory({
    Icon: NeoMarkerIcon
});

class GeocoderMarker extends React.PureComponent {
    render() {
        const {
            isGeocodeVerifiedMarker,
            theme,
            className,
            useNeoIcon = false,
            ...others
        } = this.props;
        const MarkerComponent = useNeoIcon
            ? GeocoderNeoMarkerComponent
            : GeocoderMarkerComponent;
        return (
            <MarkerComponent
                {...others}
                theme={theme}
                className={classnames(className, {
                    [theme.isGeocodeVerifiedMarker]: isGeocodeVerifiedMarker
                })}
            />
        );
    }
}
const mapStateToProps = (state, props) => {
    const isEditInProgress = LocationGeocodeEditSelectors.getIsEditingLocation(
        state,
        props
    );
    const isValidateInProgress = LocationGeocodeEditSelectors.getIsValidatingLocation(
        state,
        props
    );
    return {
        isMarkerLoading: isEditInProgress || isValidateInProgress
    };
};
const ThemedGeocoderMarker = compose(
    withRouter,
    connect(mapStateToProps)
)(themr('GeocoderMarker', geocoderMarkerTheme)(GeocoderMarker));

const SpiderGeocoderMarker = spiderLocationMarkerFactory({
    Marker: ThemedGeocoderMarker
});

export { SpiderGeocoderMarker, ThemedGeocoderMarker as GeocoderMarker };
export default ThemedGeocoderMarker;
